__turbopack_context__.v({
  "panelCloseButton": "styles-module__wmbyWq__panelCloseButton",
  "panelIcon": "styles-module__wmbyWq__panelIcon",
  "panelMargin": "styles-module__wmbyWq__panelMargin",
  "panelWrapper": "styles-module__wmbyWq__panelWrapper",
});
